import React, { useMemo } from "react";
import { apiUTCToLocalDateTime } from "@jugl-web/utils";
import isSameDay from "date-fns/isSameDay";
import { WebChatBotMessageModel } from "@jugl-web/rest-api";
import { WebChatMessageBubble } from "../WebChatMessageBubble";
import { CRMInfoMessage } from "../CRMInfoMessage";

export const WebChatMessageItem: React.FC<{
  message: WebChatBotMessageModel;
  messages: WebChatBotMessageModel[];
}> = ({ message, messages }) => {
  const groupInfo = useMemo(() => {
    const idx = messages.findIndex((item) => item.msg_id === message.msg_id);

    const result = {
      isFirst: false,
      isLast: false,
    };
    const prevMessage = messages[idx - 1];
    const nextMessage = messages[idx + 1];
    if (
      !prevMessage ||
      prevMessage?.from !== message.from ||
      prevMessage?.type === "info" ||
      prevMessage?.auto_response !== message.auto_response ||
      !isSameDay(
        apiUTCToLocalDateTime(prevMessage.inserted_at),
        apiUTCToLocalDateTime(message.inserted_at)
      )
    ) {
      result.isFirst = true;
    }
    if (
      !nextMessage ||
      nextMessage?.from !== message.from ||
      nextMessage?.type === "info" ||
      nextMessage.auto_response !== message.auto_response
    ) {
      result.isLast = true;
    }

    return result;
  }, [message, messages]);

  const $content = useMemo(() => {
    if (message.type === "info") {
      return (
        <CRMInfoMessage
          message={message.payload.text}
          timestamp={message.inserted_at}
        />
      );
    }

    return <WebChatMessageBubble message={message} groupInfo={groupInfo} />;
  }, [groupInfo, message]);

  return $content;
};
